import { render, staticRenderFns } from "./need-credits-modal.vue?vue&type=template&id=300d4855&scoped=true"
import script from "./need-credits-modal.vue?vue&type=script&lang=js"
export * from "./need-credits-modal.vue?vue&type=script&lang=js"
import style0 from "./need-credits-modal.vue?vue&type=style&index=0&id=300d4855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300d4855",
  null
  
)

export default component.exports